<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h6>
							<button class="back-btn" type="button" @click="back()">
								<i class="fas fa-arrow-left"></i>
							</button>
							 Edit Batch
						</h6>
					</div>
					<div class="card-body">
						<form @submit.prevent="onSubmit">
							<div v-if="message" class="alert alert-danger">{{ message }}</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="code1" class="col-form-label">Batch Code1 <span class="text-danger">*</span></label>
									<select v-model="batchRequest.code1" @blur="validationRule()" class="form-control" id="code1">
										<option value="">Select Code</option>
										<option v-for="code in code1" :key="code" :value="code">{{ code }}</option>
									</select>
									<small class="text-danger">{{validationData.code1}}</small>
								</div>
								<div class="col-md-6">
									<label for="code2" class="col-form-label">Batch Code2 <span class="text-danger">*</span></label>
									<select v-model="batchRequest.code2" @blur="validationRule()" class="form-control" id="code2">
										<option value="">Select Code</option>
										<option v-for="code in code2" :key="code" :value="code">{{ code }}</option>
									</select>
									<small class="text-danger">{{validationData.code2}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="code3" class="col-form-label">Batch Code3 <span class="text-danger">*</span></label>
									<select v-model="batchRequest.code3" @blur="validationRule()" class="form-control" id="code3">
										<option value="">Select Code</option>
										<option v-for="code in code3" :key="code" :value="code">{{ code }}</option>
									</select>
									<small class="text-danger">{{validationData.code3}}</small>
								</div>
								<div class="col-md-6">
									<label for="name" class="col-form-label">Batch Name <span class="text-danger">*</span></label>
									<input type="text" v-model="batchRequest.name" @blur="validationRule()" class="form-control" id="name">
									<small class="text-danger">{{validationData.name}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="start_date" class="col-form-label">Start Date <span class="text-danger">*</span></label>
									<input type="date" v-model="batchRequest.start_date" @blur="validationRule()" class="form-control" id="start_date">
									<small class="text-danger">{{validationData.start_date}}</small>
								</div>
								<div class="col-md-6">
									<label for="end_date" class="col-form-label">End Date <span class="text-danger">*</span></label>
									<input type="date" v-model="batchRequest.end_date" @blur="validationRule()" class="form-control" id="end_date">
									<small class="text-danger">{{validationData.end_date}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="code3" class="col-form-label">Description </label>
									<textarea v-model="batchRequest.description" @blur="validationRule()" class="form-control" id="description" rows="3"></textarea>	
									<small class="text-danger">{{validationData.description}}</small>
								</div>
								<div class="col-md-6 pt-4">
									<div class="form-check" style="margin-top: 20px;">
										<input class="form-check-input" type="checkbox" id="activeCheckbox" v-model="batchRequest.active">
										<label class="form-check-label" for="activeCheckbox">
											Active
										</label>
									</div>
								</div>
							</div>

							<button type="submit" class="btn btn-primary float-save">Submit</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'bankEdit',
		metaInfo: {
            title: "Bank Info Edit",
            titleTemplate: "%s ← MIC",
        },
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				paymentMethod: [],
				message: "",
				code1: [
					"MBA",
					"BSc",
					"HND",
					"IFP",
					"Y12",
					"Y11",
					"Y10",
					"Y9",
				],
				code2: [
					"01",
					"02",
					"03",
					"04",
					"05",
					"06",
					"07",
					"08",
					"09",
					"10",
				],
				code3:["2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025", "2026", "2027", "2028", "2029", "2030"],
				filter: {
					page: "",
					per_page: "",
					sort_direction: "",
					sort_by: "",
					search: "",
					date_from: "",
					date_to: "",
					status: ""
				},
				batchRequest: {
					name: "",
					code1: "",
					code2: "",
					code3: "",
					start_date: "",
					end_date: "",
					description: "",
					active: false
				},
				validationData: {
					name: "",
					code1: "",
					code2: "",
					code3: "",
					start_date: "",
					end_date: "",
				}
			}
		},
		watch: {
			async $route(to, from) {
			},
		},
		computed: {},
		methods: {
			...mapActions({
				batchUpdateAction: 'batchUpdateAction',
				batchDetailAction: 'batchDetailAction',
			}),
			async getBatchDetail(){
				await this.batchDetailAction({
					id: this.batchRequest.id
				}).then(res => {
				console.log(res);
					this.batchRequest.name = res.data.name
					this.batchRequest.code1 = res.data.code1
					this.batchRequest.code2 = res.data.code2
					this.batchRequest.code3 = res.data.code3
					this.batchRequest.start_date = res.data.start_date
					this.batchRequest.end_date = res.data.end_date
					this.batchRequest.description = res.data.description
					this.batchRequest.active = res.data.is_active == true ? true : false
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async onSubmit() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
		
				const formData = new FormData();
				formData.append('id', this.batchRequest.id);
				formData.append('name', this.batchRequest.name);
				formData.append('code1', this.batchRequest.code1);
				formData.append('code2', this.batchRequest.code2);
				formData.append('code3', this.batchRequest.code3);
				formData.append('start_date', this.batchRequest.start_date);
				formData.append('end_date', this.batchRequest.end_date);
				formData.append('description', this.batchRequest.description);
				formData.append('is_active', this.batchRequest.active ? 1 : 0);

				await this.batchUpdateAction(
					formData
				).then(res => {
					if(res.success === true) {
						this.back()
					} else {
						this.message = res.message
					}
					this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
			back() {
				this.$router.replace({ 
					path: 'batch-list', 
					query: { 
						page: this.filter.page, 
						orderBy: this.filter.orderBy, 
						sortKey: this.filter.sortKey, 
						search: this.filter.search,
						date_from: this.filter.date_from,
						date_to: this.filter.date_to,
						status: this.filter.status
					} 
				}).catch(()=>{})
			},
			validationRule() {
				let isValidation = []
				if (this.batchRequest.code1 == "") {
					this.validationData.code1 = "The code1 field is required."
					isValidation.push(true)
				} else {
					this.validationData.code1 = ""
					isValidation.push(false)
				}
				if (this.batchRequest.code2 == "") {
					this.validationData.code2 = "The code2 field is required."
					isValidation.push(true)
				} else {
					this.validationData.code2 = ""
					isValidation.push(false)
				}
				if (this.batchRequest.code3 == "") {
					this.validationData.code3 = "The code3 field is required."
					isValidation.push(true)
				} else {
					this.validationData.code3 = ""
					isValidation.push(false)
				}
				if (this.batchRequest.name == "") {
					this.validationData.name = "The name field is required."
					isValidation.push(true)
				} else {
					this.validationData.name = ""
					isValidation.push(false)
				}
				if (this.batchRequest.start_date == "") {
					this.validationData.start_date = "The start date field is required."
					isValidation.push(true)
				} else {
					this.validationData.start_date = ""
					isValidation.push(false)
				}
				if (this.batchRequest.end_date == "") {
					this.validationData.end_date = "The end date field is required."
					isValidation.push(true)
				} else {
					this.validationData.end_date = ""
					isValidation.push(false)
				}

				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}
		},
		async mounted() {
			this.filter.page = this.$route.query.page
			this.filter.per_page = this.$route.query.per_page
			this.filter.sort_direction = this.$route.query.sort_direction
			this.filter.sort_by = this.$route.query.sort_by
            this.filter.search = this.$route.query.search
            this.filter.date_from = this.$route.query.date_from
			this.filter.date_to = this.$route.query.date_to
			this.filter.status = this.$route.query.status
			this.batchRequest.id = this.$route.query.id
			await this.getBatchDetail()
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}
</style>